export const UserDetails = "UserDetails" ;